(() => {
  if (window.SiamkickShippingEstimate) return;

  const STAND_IN = {
    AL: ["", "1001"],              AR: ["C", "1001"],
    AM: ["", "0001"],              AU: ["NSW", "2000"],
    AT: ["", "1010"],              BY: ["", "220000"],
    BE: ["", "1000"],              BO: ["L", "0001"],
    BA: ["", "71000"],             BR: ["SP", "01000-000"],
    BG: ["", "1000"],              KH: ["", "120101"],
    CA: ["ON", "M5V 2T6"],         CL: ["RM", "8320000"],
    CN: ["BJ", "100000"],          CO: ["DC", "110111"],
    HR: ["", "10000"],             CY: ["", "1010"],
    CZ: ["", "11000"],             DK: ["", "1050"],
    EC: ["P", "170101"],           EE: ["", "10111"],
    FI: ["", "00100"],             FR: ["", "75001"],
    GE: ["", "0101"],              DE: ["", "10115"],
    GR: ["", "10431"],             HK: ["Hong Kong Island", "999077"],
    HU: ["", "1011"],              IS: ["", "101"],
    IN: ["DL", "110001"],          ID: ["JK", "10110"],
    IE: ["D", "D01 F5P2"],         IT: ["RM", "00184"],
    JP: ["JP-13", "100-0001"],     KZ: ["", "010000"],
    KG: ["", "720001"],            LV: ["", "1050"],
    LU: ["", "1111"],              MO: ["", "999078"],
    MY: ["KUL", "50000"],          MV: ["", "20026"],
    MX: ["CMX", "01000"],          MD: ["", "2001"],
    MC: ["", "98000"],             NL: ["", "1011 AB"],
    NZ: ["", "6011"],              NO: ["", "0150"],
    PY: ["", "001001"],            PE: ["LIM", "15001"],
    PH: ["00", "1000"],            PL: ["", "00-001"],
    PT: ["Lisboa", "1000-001"],    RO: ["B", "010011"],
    RU: ["MOW", "101000"],         SA: ["", "11564"],
    RS: ["", "11000"],             SG: ["", "018956"],
    SK: ["", "81101"],             SI: ["", "1000"],
    ZA: ["GT", "2000"],            KR: ["Seoul", "04524"],
    ES: ["M", "28001"],            SE: ["", "11120"],
    CH: ["", "8001"],              TW: ["", "100"],
    TH: ["Bangkok", "10110"],      TR: ["", "34110"],
    UA: ["", "01001"],             AE: ["DU", "00000"],
    GB: ["", "SW1A 1AA"],          US: ["CA", "90001"],
    UY: ["Montevideo", "11000"],   UZ: ["", "100000"],
    VE: ["A", "1010"],             VN: ["", "100000"],
  };

  const CACHE_TTL_MS = 5 * 60 * 1000;
  const REQUEST_TIMEOUT_MS = 6000;
  const RATE_DEADLINE_MS = 15000;
  const POLL_DELAYS_MS = [200, 350, 500, 700, 950, 1250, 1600, 2100, 2600];
  const cache = new Map();
  const inFlight = new Map();
  let requestSequence = 0;

  function formatMoney(amount) {
    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
    const locale = document.documentElement.lang || navigator.language || "en";
    try {
      return new Intl.NumberFormat(locale, { style: "currency", currency }).format(amount);
    } catch (error) {
      return currency + " " + amount.toFixed(2);
    }
  }

  function activeConverterCurrency() {
    const converted = document.querySelector(".buckscc-converted[bucks-currency]");
    return converted ? converted.getAttribute("bucks-currency") || "" : "";
  }

  function refreshCurrency(root) {
    const targetCurrency = activeConverterCurrency();
    if (!targetCurrency) return;

    const scope = root && root.querySelectorAll ? root : document;
    const targets = Array.from(scope.querySelectorAll("[data-currency-refresh]"));
    if (scope.matches && scope.matches("[data-currency-refresh]")) targets.unshift(scope);

    if (window.bucksCC && typeof window.bucksCC.reConvert === "function") {
      try {
        window.bucksCC.reConvert();
      } catch {}
    }

    targets.forEach((target) => {
      if (!/\d/.test(target.textContent || "")) return;

      const isConverted = () => {
        const converted = target.matches(".buckscc-converted")
          ? target
          : target.querySelector(".buckscc-converted");
        return converted && converted.getAttribute("bucks-currency") === targetCurrency;
      };

      if (isConverted()) {
        target.classList.remove("is-currency-pending");
        return;
      }

      target.classList.add("is-currency-pending");
      const observer = new MutationObserver(() => {
        if (!isConverted()) return;
        target.classList.remove("is-currency-pending");
        observer.disconnect();
      });
      observer.observe(target, { attributes: true, childList: true, subtree: true });
      window.setTimeout(() => {
        target.classList.remove("is-currency-pending");
        observer.disconnect();
      }, 3500);
    });
  }

  function syncShippingReward(free) {
    document.querySelectorAll("[data-cpb]").forEach((bar) => {
      const shipping = bar.querySelector('[data-cpb-seg="shipping"]');
      const discount = bar.querySelector('[data-cpb-seg="discount"]');
      if (!shipping || !discount) return;

      const total = Number(bar.dataset.originalTotal || 0);
      const firstThreshold = Number(bar.dataset.t1 || 0);
      const discountThreshold = Number(bar.dataset.t2 || 1);
      const discountSpan = Math.max(discountThreshold - firstThreshold, 1);
      const shippingFill = free
        ? 100
        : Math.min(100, (total * 100) / Math.max(firstThreshold, 1));
      let discountFill = total >= firstThreshold
        ? Math.min(100, ((total - firstThreshold) * 100) / discountSpan)
        : 0;

      shipping.hidden = false;
      shipping.classList.toggle("is-complete", free);
      shipping.style.flex = String(Math.max(firstThreshold, 1));
      shipping.style.setProperty("--cpb-fill", shippingFill + "%");
      const shippingFillElement = shipping.querySelector("[data-cpb-seg-fill]");
      if (shippingFillElement) shippingFillElement.style.width = shippingFill + "%";

      discount.style.flex = String(discountSpan);

      if (discount.classList.contains("is-complete")) discountFill = 100;
      discount.style.setProperty("--cpb-fill", discountFill + "%");
      const fillElement = discount.querySelector("[data-cpb-seg-fill]");
      if (fillElement) fillElement.style.width = discountFill + "%";
    });
  }

  function localeRoot() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return String(root || "/").replace(/\/?$/, "/");
  }

  function shippingParams(code) {
    const standIn = STAND_IN[code];
    if (!standIn) return null;
    const params = new URLSearchParams();
    params.set("shipping_address[country]", code);
    params.set("shipping_address[zip]", standIn[1]);
    if (standIn[0]) params.set("shipping_address[province]", standIn[0]);
    return params;
  }

  function wait(milliseconds) {
    return new Promise((resolve) => window.setTimeout(resolve, milliseconds));
  }

  async function request(url, options = {}, deadline = Date.now() + REQUEST_TIMEOUT_MS) {
    const controller = new AbortController();
    const remaining = Math.max(1, deadline - Date.now());
    const timeout = window.setTimeout(
      () => controller.abort(),
      Math.min(REQUEST_TIMEOUT_MS, remaining),
    );
    try {
      return await fetch(url, {
        ...options,
        headers: { Accept: "application/json", ...(options.headers || {}) },
        signal: controller.signal,
      });
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function prepareRates(params, deadline) {
    const url = localeRoot() + "cart/prepare_shipping_rates.json?" + params.toString();
    const response = await request(url, { method: "POST" }, deadline);
    if (!response.ok) throw new Error("Shipping rate preparation failed");
  }

  async function pollRates(params, deadline) {
    const url = localeRoot() + "cart/async_shipping_rates.json?" + params.toString();

    for (const delay of POLL_DELAYS_MS) {
      const remaining = deadline - Date.now();
      if (remaining <= 0) break;
      await wait(Math.min(delay, remaining));
      if (Date.now() >= deadline) break;
      const response = await request(url, {}, deadline);
      if (response.status === 202 || response.status === 429) continue;
      if (!response.ok) throw new Error("Shipping rate polling failed");

      const text = await response.text();
      if (!text.trim()) continue;
      const body = JSON.parse(text);
      if (body === null) continue;
      if (Array.isArray(body.shipping_rates)) return body.shipping_rates;
      throw new Error("Shipping rate response was invalid");
    }

    throw new Error("Shipping rate calculation timed out");
  }

  function lowestRate(rates) {
    const pricedRates = rates
      .map((rate) => ({ rate, amount: Number.parseFloat(rate.price) }))
      .filter((entry) => Number.isFinite(entry.amount));
    if (!pricedRates.length) return null;
    const lowest = pricedRates.reduce((current, entry) =>
      entry.amount < current.amount ? entry : current,
    );
    return { price: lowest.rate.price };
  }

  async function calculateRate(code) {
    const params = shippingParams(code);
    if (!params) return null;
    const deadline = Date.now() + RATE_DEADLINE_MS;
    await prepareRates(params, deadline);
    return lowestRate(await pollRates(params, deadline));
  }

  function pruneCache() {
    const now = Date.now();
    for (const [key, entry] of cache) {
      if (entry.expiresAt <= now) cache.delete(key);
    }
    while (cache.size > 32) cache.delete(cache.keys().next().value);
  }

  function rateFor(key, code) {
    pruneCache();
    const cached = cache.get(key);
    if (cached) return Promise.resolve(cached.rate);
    if (inFlight.has(key)) return inFlight.get(key);

    const pending = calculateRate(code)
      .then((rate) => {
        cache.set(key, { rate, expiresAt: Date.now() + CACHE_TTL_MS });
        return rate;
      })
      .finally(() => inFlight.delete(key));
    inFlight.set(key, pending);
    return pending;
  }

  function resetShipping(host) {
    const value = host.querySelector("[data-shipping-estimate-value]");
    if (!value) return;
    value.classList.remove("cart-shipping__value--free", "is-currency-pending");
    value.removeAttribute("data-currency-refresh");
    value.textContent = host.dataset.labelFallback || "9.99 USD";
    value.setAttribute(
      "aria-label",
      host.dataset.labelFallbackFull || "Estimated shipping 9.99 USD",
    );
    syncShippingReward(false);
  }

  function requestIsCurrent(host, token, code, signature) {
    return Boolean(
      host.isConnected &&
      host.dataset.shippingEstimateRequest === token &&
      String(host.dataset.countryCode || "").toUpperCase() === code &&
      String(host.dataset.cartSignature || host.dataset.cartTotal || "") === signature,
    );
  }

  function paintShipping(host, rate) {
    const value = host.querySelector("[data-shipping-estimate-value]");
    if (!value) return;
    const amount = parseFloat(rate.price);
    const free = amount === 0;
    value.classList.toggle("cart-shipping__value--free", free);
    value.removeAttribute("aria-label");
    syncShippingReward(free);

    if (free) {
      value.removeAttribute("data-currency-refresh");
      value.textContent = host.dataset.labelFree || "Free";
      return;
    }

    const money = document.createElement("span");
    money.className = "money";
    money.textContent = formatMoney(amount);
    value.textContent = "";
    value.append(money);
    value.setAttribute("data-currency-refresh", "");
    refreshCurrency(value);
  }

  async function apply(host) {
    if (!host) return;
    const code = String(host.dataset.countryCode || "").toUpperCase();
    const signature = String(host.dataset.cartSignature || host.dataset.cartTotal || "");
    const key = code + ":" + signature;
    if (
      host.dataset.shippingEstimateKey === key &&
      ["loading", "done"].includes(host.dataset.shippingEstimateState)
    ) {
      return;
    }

    const token = String(++requestSequence);
    host.dataset.shippingEstimateKey = key;
    host.dataset.shippingEstimateRequest = token;
    host.dataset.shippingEstimateState = "loading";
    resetShipping(host);

    if (!code || !STAND_IN[code]) {
      host.dataset.shippingEstimateState = "done";
      return;
    }

    try {
      const rate = await rateFor(key, code);
      if (!requestIsCurrent(host, token, code, signature)) return;
      if (rate) paintShipping(host, rate);
      else resetShipping(host);
      host.dataset.shippingEstimateState = "done";
    } catch (error) {
      if (!requestIsCurrent(host, token, code, signature)) return;
      resetShipping(host);
      host.dataset.shippingEstimateState = "done";
    }
  }

  function run() {
    document.querySelectorAll("[data-shipping-estimate]").forEach(apply);
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    Promise.resolve().then(() => {
      queued = false;
      run();
    });
  }

  if (typeof MutationObserver === "function") {
    for (const id of ["CartDrawer", "main-cart-footer"]) {
      const host = document.getElementById(id);
      if (host) new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    }
  }

  window.SiamkickShippingEstimate = { run };
  window.SiamkickCurrencyRefresh = refreshCurrency;
  refreshCurrency(document);
  run();
})();
